import LineSuitcaseIcon from 'LuxKit/Icons/line/LineSuitcaseIcon'
import config from 'constants/config'
import { useOrdersByDepartureStatus } from 'hooks/useOrdersByDepartureStatus'
import type { ComponentProps } from 'react'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import { sum } from 'lib/array/arrayUtils'
import NavBarListItemIcon from '../NavBarListItemIcon'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuMyEscapesListItem(props: InheritedListItemProps) {
  const intl = useIntl()
  const { upcoming } = useOrdersByDepartureStatus()

  const upcomingCopy = useMemo<string | undefined>(() => {
    const numberOfUpcoming = sum([upcoming.length])
    if (numberOfUpcoming === 0) {
      return undefined
    }
    return intl.formatMessage(
      {
        id: 'LhUJ5csC5hnMOdoNj6x0',
        defaultMessage: '{count, plural, one {# upcoming} other {# upcoming}}',
        description: 'Number of upcoming escapes count in the navigation bar',
      },
      { count: numberOfUpcoming },
    )
  }, [intl, upcoming.length])

  const title = useMemo(() => {
    const purchaseSynonym = config.brandConfig.purchaseSynonym
    if (purchaseSynonym === 'booking') {
      return intl.formatMessage({
        id: 'fMLSetH4pGoPam_6SvXk',
        defaultMessage: 'My Bookings',
        description: 'Navigation item title for my escapes page when purchaseSynonym is booking',
      })
    }
    if (purchaseSynonym === 'escape') {
      return intl.formatMessage({
        id: 'b7dx-lBBNLg0Ge0icsqm',
        defaultMessage: 'My Escapes',
        description: 'Navigation item title for my escapes page when purchaseSynonym is escape',
      })
    }
    return intl.formatMessage({
      id: '-36U3TQyuYVbU3CJeL8K',
      defaultMessage: 'My Purchases',
      description: 'Navigation item title for my escapes page when purchaseSynonym is purchase',
    })
  }, [intl])

  return <NavBarListItem
    {...props}
    startIcon={<NavBarListItemIcon Icon={LineSuitcaseIcon} />}
    title={title}
    titleFormat="titlecase"
    endTitle={upcomingCopy}
    to="/account/my-escapes"
  />
}

export default AccountMenuMyEscapesListItem
